
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useToast } from '@/hooks/use-toast';

export const usePropertyFeatureMutations = () => {
  const queryClient = useQueryClient();
  const { toast } = useToast();

  const updatePropertyFeatures = useMutation({
    mutationFn: async ({ propertyId, featureIds }: { propertyId: string; featureIds: string[] }) => {
      console.log('🏷️ Updating property features:', { propertyId, featureIds });

      // First, delete all existing features for this property
      const { error: deleteError } = await supabase
        .from('property_features')
        .delete()
        .eq('property_id', propertyId);

      if (deleteError) {
        console.error('Error deleting existing property features:', deleteError);
        throw deleteError;
      }

      // Then, insert new features if any
      if (featureIds.length > 0) {
        const insertData = featureIds.map(featureId => ({
          property_id: propertyId,
          feature_id: featureId,
        }));

        const { error: insertError } = await supabase
          .from('property_features')
          .insert(insertData);

        if (insertError) {
          console.error('Error inserting property features:', insertError);
          throw insertError;
        }
      }

      console.log('✅ Property features updated successfully');
    },
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ['property-features', variables.propertyId] });
      queryClient.invalidateQueries({ queryKey: ['properties'] });
      queryClient.invalidateQueries({ queryKey: ['property', variables.propertyId] });
      toast({
        title: "Features actualizados",
        description: "Los features de la propiedad han sido actualizados exitosamente",
      });
    },
    onError: (error: any) => {
      console.error('❌ Error updating property features:', error);
      toast({
        title: "Error",
        description: `Error al actualizar los features: ${error.message}`,
        variant: "destructive",
      });
    },
  });

  return {
    updatePropertyFeatures,
  };
};
